import { createContext, useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

const ScrollContext = createContext({ scrollTo: () => {} });

export const SmoothScroll = ({ children }) => {
  const lenisRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, wheelMultiplier: 0.9 });
    lenisRef.current = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    const lenis = lenisRef.current;
    if (!lenis) return;
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) lenis.scrollTo(el, { offset: -90, duration: 1.2 });
      }, 120);
    } else {
      lenis.scrollTo(0, { immediate: true });
    }
  }, [location.pathname, location.hash]);

  const scrollTo = (target, opts = {}) => lenisRef.current?.scrollTo(target, { offset: -90, duration: 1.2, ...opts });

  return <ScrollContext.Provider value={{ scrollTo }}>{children}</ScrollContext.Provider>;
};

export const useSmoothScroll = () => useContext(ScrollContext);
